import { mapGetters } from 'vuex'

const mixins = {
  computed: {
    ...mapGetters('ui', ['previousMarket']),
    isPreviousMarketSameAsCurrent() {
      return this.previousMarket === this.clientModel.currentMarket
    }
  },
  methods: {
    setPreviousMarketToCurrent(reloadSite = false) {
      this.$store.dispatch('ui/setPreviousMarket', this.clientModel.currentMarket)
      this.$store.dispatch('checkout/clearCheckout')

      if (reloadSite) {
        // eslint-disable-next-line
        window.location.href = window.location.href
      }
    }
  }
}

export default mixins
